import Immutable from 'immutable'
import { checkEmail, apiHandleStatus } from '../../lib/index'
import MainReducer from '../main/reducer'

import capiSingleton from '../../api/carrotApi'
const capi = capiSingleton.get()

const TYPES = {
    CLEAR: 'LOGIN_CLEAR',
    CLEAR_ERRORS: 'LOGIN_CLEAR_ERRORS',
    SET_LOADING: 'LOGIN_SET_LOADING',
    SET_STAGE: 'LOGIN_SET_STAGE',
    SET_EMAIL: 'LOGIN_SET_EMAIL',
    SET_EMAIL_ERROR: 'LOGIN_SET_EMAIL_ERROR',
    SET_PIN: 'LOGIN_SET_PIN',
    SET_PIN_ERROR: 'LOGIN_SET_PIN_ERROR',
    SET_NO_BUSINESS_ERROR: 'LOGIN_SET_NO_BUSINESS_ERROR'
}

export default class LoginReducer {
    static componentName = 'LoginReducer'
    static NAME = 'login_reducer'
    static TYPES = TYPES
    static INITIAL_STATE = Immutable.fromJS({})

    static setLoading(loading) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_LOADING,
            loading
        })
    }

    static setStage(stage) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_STAGE,
            stage
        })
    }

    static setEmail(email) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_EMAIL,
            email
        })
    }

    static setEmailError(error) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_EMAIL_ERROR,
            error
        })
    }

    static setPin(pin) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_PIN,
            pin
        })
    }

    static setPinError(error) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_PIN_ERROR,
            error
        })
    }

    static setNoBusinessError(error) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_NO_BUSINESS_ERROR,
            error
        })
    }

    static clearErrors() {
        return (dispatch, getState) => dispatch({
            type: TYPES.CLEAR_ERRORS
        })
    }

    static clear() {
        return (dispatch, getState) => dispatch({
            type: TYPES.CLEAR
        })
    }

    static verifyPin(email, pin) {
        return (dispatch, getState) => {
            const trimmedEmail = email ? email.trim() : ''

            dispatch(LoginReducer.clearErrors())
            dispatch(LoginReducer.setLoading(true))

            if (checkEmail(trimmedEmail)) {
                capi.passwordGrant(
                    trimmedEmail,
                    pin
                ).then((res) => {
                    apiHandleStatus(res, [200])

                    dispatch(MainReducer.setProfileAndCreds(
                        res.data,
                        capi.getCredentials(),
                        {
                            credentialSetOn: new Date().getTime()
                        }
                    ))

                    capi.IdentitySwitcher.retrieve().then((res) => {
                        apiHandleStatus(res, [200])

                        dispatch(MainReducer.setBusinessIdentity(res.data))

                    }).catch((error) => {
                        dispatch(LoginReducer.setNoBusinessError(error.message))
                    })

                }).catch((error) => {
                    dispatch(LoginReducer.setPinError('Valid Pin is required'))
                })
            } else {
                dispatch(LoginReducer.setEmailError('Valid Email is required'))
            }
        }
    }

    static requestPin(email) {
        return (dispatch, getState) => {
            const trimmedEmail = email ? email.trim() : ''

            dispatch(LoginReducer.clearErrors())
            dispatch(LoginReducer.setLoading(true))

            if (checkEmail(trimmedEmail)) {
                capi.OneUseToken.create({
                    'email': trimmedEmail,
                    'email-template': 'merchant-login-link'
                }).then((res) => {
                    apiHandleStatus(res, [200])

                    dispatch(LoginReducer.clearErrors())
                    dispatch(LoginReducer.setStage('emailed'))

                    dispatch(LoginReducer.setLoading(false))

                }).catch((error) => {
                    dispatch(LoginReducer.setEmailError(error.message))
                })
            } else {
                dispatch(LoginReducer.setEmailError('Valid email address is needed'))
            }
        }
    }

    static reducer(
        state = LoginReducer.INITIAL_STATE,
        action
    ) {
        if (state == null) state = LoginReducer.INITIAL_STATE

        switch (action.type) {
            case MainReducer.TYPES.LOGOUT:
            case MainReducer.TYPES.SWITCH_CURRENT_IDENTITY:
            case TYPES.CLEAR:
                return LoginReducer.INITIAL_STATE

            case TYPES.CLEAR_ERRORS:
                return state.delete('email_error')
                        .delete('pin_error')
                        .delete('no_business_error')

            case TYPES.SET_LOADING:
                return state.set('loading', action.loading)

            case TYPES.SET_EMAIL:
                return state.set('email', action.email)

            case TYPES.SET_EMAIL_ERROR:
                return state.set('loading', false)
                        .set('email_error', action.error)

            case TYPES.SET_PIN:
                return state.set('pin', action.pin)

            case TYPES.SET_PIN_ERROR:
                return state.set('loading', false)
                        .set('pin_error', action.error)

            case TYPES.SET_NO_BUSINESS_ERROR:
                return state.set('loading', false)
                        .set('no_business_error', action.error)

            case TYPES.SET_STAGE:
                return state.set('stage', action.stage)

            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/login/reducer.js